module.exports = __webpack_public_path__ + "static/media/device.470f253c.svg";